// External URLs in one place, so changing a link never means hunting through components
import { faInstagram, faTelegram } from "@fortawesome/free-brands-svg-icons";

export const SOCIAL_LINKS = [
    { name: "Instagram", url: "https://instagram.com/code_pro.ir", icon: faInstagram },
    { name: "Telegram", url: "https://telegram.me/code_pro.ir", icon: faTelegram }
];

export const SUPPORT_URL = "https://www.goftino.com/c/2FqaT1";
export const FEEDBACK_URL = "https://survey.porsline.ir/s/ygReOZvK";